import styles from './Job.module.css';
import Section from '../components/Section/Section';
import Dropdown from 'react-dropdown'

const JobFilters = (props) => {
    const {
        uniquePoles,
        handlePoleFilterSelect,
        filteredPole,
        uniqueLines,
        handleLineFilterSelect,
        filteredLine,
        statuses,
        handleStatusFilterSelect,
        filteredStatus
    } = props;
  
    return (
        <Section>
          <div className="col py-5">
            <div className="date-section d-flex flex-column flex-sm-row flex-wrap justify-content-start">

                {/* item - Pole */}
                {uniquePoles[1] &&
                  <div className={`col-sm-6 col-md-2 pr-0 pr-md-3 pl-0 pl-sm-4 pl-md-0 mr-0 mb-3 mb-md-0 pole ${styles.filterItem}`}>
                    <label className={styles.label}>Pole</label>
                    <div className="dropdown">
                      <Dropdown
                        options={uniquePoles}
                        onChange={handlePoleFilterSelect}
                        value={filteredPole}
                        placeholder="All" />
                    </div>
                  </div>
                }

                {/* item - Line */}
                {uniqueLines[1] &&
                  <div className={`col-sm-6 col-md-2 pr-0 pr-sm-4 pr-md-3 pl-0 mr-0 mb-3 mb-md-0 line ${styles.filterItem}`}>
                    <label className={styles.label}>Line</label>
                    <div className="dropdown">
                      <Dropdown
                        options={uniqueLines}
                        onChange={handleLineFilterSelect}
                        value={filteredLine}
                        placeholder="All" />
                    </div>
                  </div>
                }
                
              <div className="col-sm-6 col-md-2 ml-sm-0 ml-md-auto pr-0 pr-sm-4 pr-md-0 pl-0 show">
                <label className={styles.label}>Status</label>
                <div className="dropdown">
                  <Dropdown
                    options={statuses}
                    onChange={handleStatusFilterSelect}
                      value={filteredStatus}
                    placeholder="Select" />
                </div>
              </div>
            </div>
          </div>
        </Section>
    );
}

export default JobFilters;